import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Input, Container } from 'reactstrap';
import styles from './ProductSelectionModal.module.scss';
import DataTable from 'react-data-table-component';
import FilterTabsCommon from '../../common/FilterTabsCommon/FilterTabsCommon';

const packagingData = [
    {
        id: 1,
        image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        stock: 1000,
        quantityToShip: 200,
        warehouseStock: 50,
    },
    {
        id: 2,
        image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        stock: 1000,
        quantityToShip: 200,
        warehouseStock: 50,
    },
    {
        id: 3,
        image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        stock: 1000,
        quantityToShip: 200,
        warehouseStock: 50,
    },
    {
        id: 4,
        image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        name: 'Blue Colored Headphones',
        sku: '#123456789',
        stock: 1000,
        quantityToShip: 200,
        warehouseStock: 50,
    },
];

const packagingColumns = [
    {
        name: "Product",
        cell: (row) => (
            <div className={styles.productInfo}>
                <img
                    src={row.image}
                    alt={row.name}
                    className={styles.productImage}
                />
                <div>
                    <div className={styles.productName}>{row.name}</div>
                    <div className={styles.productSKU}>
                        Product SKU: <span>{row.sku}</span>
                    </div>
                </div>
            </div>
        ),
        width: '280px',
    },
    {
        name: "Stock",
        selector: (row) => row.stock,
    },
    {
        name: "Quantity to Ship",
        selector: (row) => row.quantityToShip,
    },
    {
        name: "Stock present in Warehouse",
        selector: (row) => row.warehouseStock,
    },
];

const customStyles = {
    table: {
        style: {
            borderLeft: '1px solid #D9D9D9',
            borderTop: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
        },
    },
    headCells: {
        style: {
            paddingLeft: "8px",
            paddingRight: "8px",
            fontSize: '15px',
            borderRight: '1px solid #D9D9D9',
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 8px',
            borderRight: '1px solid #D9D9D9',
        },
    },
};

const nestedTabs = [
    { id: 'recommended', label: 'Recommended' },
    { id: 'all', label: 'All' },
    { id: 'recentlyAdded', label: 'Recently Added' },
];

const ProductSelectionModal = ({
    isSecondModalOpen,
    toggleSecondModal,
    selectedCategories,
    searchQuery,
    handleSearchChange,
}) => {
    const [activeCategory, setActiveCategory] = useState(null);
    const [activeNestedFilter, setActiveNestedFilter] = useState('recommended');

    useEffect(() => {
        if (selectedCategories && selectedCategories.length > 0) {
            setActiveCategory(selectedCategories[0].toLowerCase());
        }
    }, [selectedCategories]);

    const categoryTabs = selectedCategories.map((category, index) => ({
        id: category.toLowerCase(),
        label: category,
    }));

    return (
        <Modal isOpen={isSecondModalOpen} toggle={toggleSecondModal} size="lg" centered>
            <ModalHeader toggle={toggleSecondModal}>
                <p className={styles.modalHeader}>Select Products</p>
            </ModalHeader>
            <ModalBody>

                {/* Search Field */}
                <div className={styles.searchContainer}>
                    <Input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className={styles.searchInput}
                    />
                </div>

                {/* Filter Tabs */}
                <div className={styles.filterContainer}>
                    <FilterTabsCommon
                        tabs={categoryTabs}
                        activeTab={activeCategory}
                        setActiveTab={setActiveCategory}
                    />
                </div>

                {/* Nested Filter Tabs */}
                <div>
                    <FilterTabsCommon
                        tabs={nestedTabs}
                        activeTab={activeNestedFilter}
                        setActiveTab={setActiveNestedFilter}
                    />
                </div>

                {/* Total Products and Products Table */}
                <div className={styles.productsContainer}>
                    <Container fluid className={styles.totalProducts}>
                        <span>Total Products: 300</span>
                    </Container>

                    <Container fluid className={styles.productsTable}>
                        <DataTable
                            columns={packagingColumns}
                            data={packagingData}
                            customStyles={customStyles}
                            selectableRows
                            highlightOnHover
                            pagination
                        />
                    </Container>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ProductSelectionModal;
